// src/components/NavigateToButton.tsx
import { Button, SxProps } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useStateAwareNavigation } from '../hooks/useStateAwareNavigation';
import { trackEvent } from './GoogleAnalytics';

interface NavigateToButtonProps {
  'aria-label'?: string;
  to?: string; // Optional direct URL
  billSlug?: string; // Optional bill slug for state-aware navigation
  onClick: () => void;
  children: React.ReactNode;
  sx?: SxProps; // Add sx prop for custom styling
  variant?: 'text' | 'outlined' | 'contained'; // Add variant prop
  size?: 'small' | 'medium' | 'large'; // Add size prop
}

const NavigateToButton: React.FC<NavigateToButtonProps> = ({
  'aria-label': ariaLabel,
  to,
  billSlug,
  onClick,
  children,
  sx,
  variant = 'outlined', // Default to outlined
  size = 'medium', // Default to medium
}) => {
  const navigate = useNavigate();
  const { navigateToBill } = useStateAwareNavigation();

  const handleClick = () => {
    if (billSlug) {
      trackEvent('bill_card_click', 'bills', billSlug);
      // Use state-aware navigation for bill slugs
      navigateToBill(billSlug);
    } else if (to) {
      // Use direct navigation for explicit URLs
      navigate(to);
    }
    onClick();
  };

  return (
    <Button
      aria-label={ariaLabel}
      onClick={handleClick}
      variant={variant}
      size={size}
      sx={{ outline: 'inherit', ...sx }}
    >
      {children}
    </Button>
  );
};

export default NavigateToButton;
